
import { useState } from "react";
import { format, parse } from "date-fns";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { ApplicationFormValues } from "./formSchema";

export function useApplicationSubmit(onSuccess: () => void, challengeId: string = "lamour-surcote") {
  const { toast } = useToast();
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const handleSubmit = async (data: ApplicationFormValues) => {
    setIsSubmitting(true);
    
    try {
      // Convert date string to ISO format for storage
      let birthDateFormatted = "";
      try {
        const parsedDate = parse(data.birthDate, 'dd/MM/yyyy', new Date());
        birthDateFormatted = format(parsedDate, 'yyyy-MM-dd');
      } catch (e) {
        console.error('Error parsing date:', e);
        toast({
          title: "Erreur",
          description: "Format de date invalide. Veuillez utiliser JJ/MM/AAAA.",
          variant: "destructive",
        });
        setIsSubmitting(false);
        return;
      }

      const { error } = await supabase
        .from('challenge_applications' as any)
        .insert({
          full_name: data.fullName,
          tiktok_handle: data.tiktokHandle,
          email: data.email,
          phone_number: data.phoneNumber,
          birth_date: birthDateFormatted,
          creative_approach: data.creativeApproach,
          motivation: data.motivation,
          accepted_contact: data.acceptedContact,
          challenge_id: challengeId,
        } as any);

      if (error) throw error;

      toast({
        title: "Candidature envoyée !",
        description: "Nous vous recontacterons très bientôt.",
        variant: "default",
      });
      
      onSuccess();
    } catch (error) {
      console.error('Error submitting application:', error);
      
      toast({
        title: "Erreur",
        description: "Un problème est survenu lors de l'envoi de votre candidature. Veuillez réessayer.",
        variant: "destructive",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return { 
    handleSubmit,
    isSubmitting
  };
}
